import { useNavigate } from "react-router-dom";

import { MENU_SIDE_BAR } from "../../config/constants";
import { SCOPES } from "../../config/permission-maps";
import DashboardIcon from "../../assets/menuIcon/dashboardIcon";
import { menuBarIconMap } from "../../utils/menuBar";
import { getPathName } from "../../utils/utils";
import PermissionsGate from "../PermissionGate";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar
} from "../ui/common/sidebar";

/**
 * Main navigation. Renders the same MENU_SIDE_BAR items, the same permission
 * gating and the same active-path check as the previous MenuBar. At >=992px
 * it's a collapsible icon+label rail; below that the Sidebar primitive turns
 * it into an off-canvas drawer, so picking an item here also closes the
 * drawer instead of leaving it open over the newly-navigated page.
 */
const AppSidebar = () => {
  const navigate = useNavigate();
  const pathName = getPathName();
  const { closeMobileSidebar } = useSidebar();

  return (
    <Sidebar>
      <SidebarContent>
        {MENU_SIDE_BAR.map((section, sectionIndex) => (
          <SidebarGroup key={sectionIndex}>
            <SidebarGroupLabel>Navigation</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {section.subTitle.map(item => {
                  if (item?.isHidden) return null;
                  const Icon = menuBarIconMap[item.name] || DashboardIcon;

                  return (
                    <PermissionsGate
                      key={item.path || item.name}
                      scopes={[SCOPES.canAccessInSideMenu]}
                      feature={item.name}
                    >
                      <SidebarMenuItem>
                        <SidebarMenuButton
                          isActive={pathName === item.path}
                          icon={<Icon />}
                          label={item.titleName}
                          onClick={() => {
                            navigate(item.path);
                            closeMobileSidebar();
                          }}
                        />
                      </SidebarMenuItem>
                    </PermissionsGate>
                  );
                })}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
    </Sidebar>
  );
};

export default AppSidebar;
